import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col ml-3" }
const _hoisted_3 = { class: "timeline-content d-flex" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = {
  key: 0,
  class: "card-header border-0"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-sm btn-success me-3",
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": "#kt_modal_pks"
    }, " Tambah PKS ")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = {
  key: 0,
  class: "text-center"
}
const _hoisted_16 = {
  key: 1,
  class: "text-center"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "symbol symbol-35px me-2",
    title: "Edit",
    style: {"cursor":"pointer"},
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_pks"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/icons/edit.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_pks",
  ref: "uploadModalRef"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_24 = { class: "modal-content rounded" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, "Update PKS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_26 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-xl-6 mb-8" }
const _hoisted_29 = { class: "row-xl-6 mb-8" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_31 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "row-xl-6 mb-8" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Status PKS", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status PKS", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: "Pending",
  key: "Pending"
}, "Pending", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: "Waiting",
  key: "Waiting"
}, "Waiting", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", {
  value: "Process",
  key: "Process"
}, "Process", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: "Approve",
  key: "Approve"
}, "Approve", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", {
  value: "Cancel",
  key: "Cancel"
}, "Cancel", -1)
const _hoisted_42 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "row-xl-6 mb-8" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Status Permintaan", -1)
const _hoisted_47 = { class: "row-xl-6 mb-8" }
const _hoisted_48 = { class: "form-label fw-bolder text-dark fs-6 mr-3" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Upload Confirmation Letter ")
const _hoisted_50 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_51 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_54 = { class: "col" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "row-xl-6 mb-8" }
const _hoisted_57 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Upload PIRO ")
const _hoisted_59 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_60 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_63 = { class: "col" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "col-xl-6 mb-8" }
const _hoisted_66 = { class: "row-xl-6 mb-8" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_68 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "row-xl-6 mb-8" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_73 = { class: "modal-footer" }
const _hoisted_74 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.tampilPKS.actorName == null || '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              (_ctx.tampilPKS.actorName != null || _ctx.tampilPKS.actorName == '')
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.tampilPKS.progressDate), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.tampilPKS.actorName), 1),
                      (
                    _ctx.tampilPKS.contractStatus == null ||
                    _ctx.tampilPKS.contractStatus == undefined
                  )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString("Status Belum Tersedia")))
                        : (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(_ctx.tampilPKS.contractStatus), 1)),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.tampilPKS.note.length > 50
                      ? _ctx.tampilPKS.note.substring(0, 50) + " ..."
                      : _ctx.tampilPKS.note), 1),
                      _hoisted_18
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_19, _hoisted_21))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "actorName",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Penanggung Jawab",
                        modelValue: _ctx.updatePKS.actorName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatePKS.actorName) = $event))
                      }, null, 8, ["modelValue"]),
                      (
                        _ctx.updatePKS.actorName == '' || _ctx.updatePKS.actorName == null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.items.erroractorName), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "contractStatus",
                        autocomplete: "off",
                        modelValue: _ctx.updatePKS.contractStatus,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatePKS.contractStatus) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36,
                          _hoisted_37,
                          _hoisted_38,
                          _hoisted_39,
                          _hoisted_40,
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (
                        _ctx.updatePKS.contractStatus == '' ||
                        _ctx.updatePKS.contractStatus == null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.items.errorcontractStatus), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44))
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "requestedStatus",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.tampilPKS.requestedStatus,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tampilPKS.requestedStatus) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, [
                        _hoisted_49,
                        (
                          _ctx.items.confirmationLetterFile != '' &&
                          _ctx.items.confirmationLetterFile != null
                        )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, " File Tersedia "))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(), _createElementBlock("input", {
                        name: "file",
                        type: "file",
                        id: "file",
                        class: "form-control form-control-lg",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleFileUpload($event))),
                        key: _ctx.items.fileInputKey
                      }, null, 32)),
                      (
                        _ctx.items.confirmationLetterFile != '' &&
                        _ctx.items.confirmationLetterFile != null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _hoisted_52,
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning btn-sm",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadCL())),
                                disabled: _ctx.items.disableButton
                              }, " Download ", 8, _hoisted_55)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, [
                        _hoisted_58,
                        (
                          _ctx.items.piroDocumentFile != '' &&
                          _ctx.items.piroDocumentFile != null
                        )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, " File Tersedia "))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(), _createElementBlock("input", {
                        name: "file2",
                        type: "file",
                        id: "file2",
                        class: "form-control form-control-lg",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleFileUpload2($event))),
                        key: _ctx.items.fileInputKey2
                      }, null, 32)),
                      (
                        _ctx.items.piroDocumentFile != '' &&
                        _ctx.items.piroDocumentFile != null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _hoisted_61,
                            _hoisted_62,
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning btn-sm",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadPiro())),
                                disabled: _ctx.items.disableButton
                              }, " Download ", 8, _hoisted_64)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "progressDate",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Tanggal",
                        modelValue: _ctx.updatePKS.progressDate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.updatePKS.progressDate) = $event))
                      }, null, 8, ["modelValue"]),
                      (
                        _ctx.updatePKS.progressDate == '' ||
                        _ctx.updatePKS.progressDate == null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.items.errorprogressDate), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_70))
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control form-control-lg",
                        type: "text",
                        placeholder: "Isi Catatan",
                        name: "note",
                        autocomplete: "off",
                        rows: "10",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.updatePKS.note) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.updatePKS.note]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.CancelUpdate()))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitAddPKS())),
                  disabled: _ctx.items.disableButton
                }, " Simpan ", 8, _hoisted_74)
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}